import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, space, transition } from './neonUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Switch', 'cyberTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      background: `${space[600]} !important`,
      border: `1px solid ${cyan[500]}20`,

      [`&${componentCls}-checked`]: {
        background: `${cyan[500]}30 !important`,
        borderColor: `${cyan[500]}60`,
        boxShadow: `0 0 8px ${cyan[500]}30`,

        [`${componentCls}-handle:before`]: {
          background: `${cyan[500]} !important`,
          boxShadow: `0 0 6px ${cyan[500]}80`,
        },
      },

      [`${componentCls}-handle:before`]: {
        background: `${cyan[700]} !important`,
      },
    },
  }
})
